import { buildBindable } from '@monofe/di';
import { bindConfigCache, injectConfigCache, TYPES, unbindConfigCache } from '@monofe/util';
const SECONDS_IN_A_DAY = 86400;
const EXPIRATION_DAYS = 21;
const EXPIRATION_THRESHOLD = EXPIRATION_DAYS * SECONDS_IN_A_DAY;

function _build() {
  return [
  /* PublicAssets */
  {
    cacheName: 'app-public-cache',
    expiration: EXPIRATION_THRESHOLD,
    maxEntries: 200,
    matcher: /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\/(?:img|image|image[s\u017F]|font|font[s\u017F])\/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/gi
  },
  /* External(Adobe) fonts */
  {
    cacheName: 'app-external-fonts-cache',
    expiration: EXPIRATION_THRESHOLD,
    maxEntries: 200,
    matcher: /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*u[s\u017F]e\.type[k\u212A]it\.net\/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/gi
  },
  /* BuildMediaAssets */
  {
    cacheName: 'app-assets-local-cache',
    expiration: EXPIRATION_THRESHOLD,
    maxEntries: 1000,
    matcher: /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\/a[s\u017F][s\u017F]et[s\u017F]?\/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/gi,
    cacheQueryOptions: {
      ignoreSearch: true,

      /* Header 'Vary: Accept-Encoding' being received for all media files */
      ignoreVary: true
    }
  },
  /* WorkspaceMedia */
  {
    cacheName: 'app-assets-remote-cache',
    expiration: EXPIRATION_THRESHOLD,
    maxEntries: 1000,

    /* Match all minus media.json */
    matcher: /app(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])GetFile/gi,
    fetchOptions: {
      /* When the browser loads the associated asset,
         we need to intercept in the service-worker & resolve. 
         By default all requests from the browser have no cors.
         Changes below allow non-opaque responses to be saved to cache */
      mode: 'cors'
    },
    cacheQueryOptions: {
      ignoreSearch: true,
      ignoreVary: true
    }
  },
  /* WorkspaceStream */
  {
    cacheName: 'app-stream-cache',
    expiration: EXPIRATION_THRESHOLD,
    maxEntries: 1000,

    /* Match all minus media.json */
    matcher: /at[s\u017F]web(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])app\/media\/[0-9]*\/(?!media(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])j[s\u017F]on(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)/gi,
    fetchOptions: {
      /* When the browser loads the associated asset,
         we need to intercept in the service-worker & resolve. 
         By default all requests from the browser have no cors.
         Changes below allow non-opaque responses to be saved to cache */
      mode: 'cors',
      headers: {
        'X-Force-Cors': 'true'
      },
      credentials: 'omit'
    },
    cacheQueryOptions: {
      /* All files which can be compressed (.html, .css from extracted html zips) may be served by the CDN as gzip
         The issue, is that it will then add header 'Vary: Accept-Encoding', by default the Vary header will void CacheStorage hits
         More info: https://stackoverflow.com/questions/58270383/workbox-pre-cached-audio-with-range-requests-router-fails-to-play-in-chrome-when */
      ignoreVary: true,
      ignoreSearch: true
    }
  }];
}

export default buildBindable({
  id: TYPES.IConfigCache,
  dependencies: [],
  bind: bindConfigCache,
  remove: unbindConfigCache,
  inject: injectConfigCache,
  build: () => Promise.resolve(_build())
});